import { useEffect } from "react";

/**
 * Asks the browser to confirm before the page closes while a photo is still
 * uploading, since closing then loses that photo. The browser shows its own
 * wording; iPhone Safari ignores the request entirely.
 */
export function useUploadPhotosLeaveWarning(uploading: boolean) {
  useEffect(() => {
    if (!uploading) {
      return;
    }

    function warn(event: BeforeUnloadEvent) {
      event.preventDefault();
    }

    window.addEventListener("beforeunload", warn);
    return () => window.removeEventListener("beforeunload", warn);
  }, [uploading]);
}
